import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';
import { isBrowser } from 'ws-scripts/modules/environment';
import { waitForInvData, useWindowDimension } from 'wsm-srp-utilities';
import { setClassNames } from 'ddc-classnames-js';
import AppliedFilters from '../components/AppliedFilters';
import ClearFilters from '../components/ClearFilters';
import VehicleCount from '../components/VehicleCount';
import FilterItem from '../components/FilterItem';
import FilterItemList from '../components/FilterItemList';
import FilterModalButton from '../components/FilterModalButton';
import InventorySort from '../components/InventorySort';
import { formatAppliedFilters } from '../utilities/filters';
import { useScrollEffect } from '../hooks/useScrollEffect';

class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.stickyFiltersRef = React.createRef();

		this.state = {
			facets: null,
			totalCount: 0,
			appliedFilters: [],
			invCount: 0
		};

		if (isBrowser) {
			waitForInvData(this, 'facet');
			waitForInvData(this, 'sortBy');
		}
	}

	componentDidMount() {
		if (window && window.DDC && window.DDC.pubsub) {
			window.DDC.pubsub.subscribe('ws-inv-data/facets', () => {
				const facetData = window.DDC.InvData.getFacets();
				const filterData = window.DDC.InvData.getAppliedFilters();
				this.setState({
					appliedFilters: formatAppliedFilters(
						filterData,
						this.props.labels
					),
					facets: facetData.facets,
					totalCount: facetData.totalCount
				});
			});
			window.DDC.pubsub.subscribe('ws-inv-data/inventory', () => {
				const { pageInfo } = window.DDC.InvData.getInventory();
				this.setState({
					invCount: pageInfo.totalCount
				});
			});
		}
	}

	static getViewportDimension() {
		const { viewportWidth } = useWindowDimension();
		return viewportWidth;
	}

	render() {
		const { appliedFilters, facets, totalCount, invCount } = this.state;
		if (!isBrowser || !window.DDC.InvData || !facets) {
			return null;
		}

		// Checking against the WidgetData object to see if sortOptions exist
		const { sortOptions } =
			window.DDC.getProperty(
				'window.DDC.WidgetData.inventory-data-bus1.props',
				window
			) || [];

		const isStickyDisabled = window.DDC.siteProperties
			? window.DDC.siteProperties.templateHeaderDisableSticky
			: false;

		return (
			<Common
				render={({ labels }) => {
					let navbarHeightCalc = 0;

					const isDesktop =
						WidgetContainer.getViewportDimension() > 992;

					const navbarHeight =
						!isDesktop && !isStickyDisabled
							? document.querySelector('.page-header')
									.offsetHeight
							: 0;

					const navbarHeightShrink = !isDesktop
						? document.querySelector(
								'.navbar-default.sticky-header-nav'
						  )
						: null;

					const navbarHeightFixedMobile = !isDesktop
						? document.querySelector(
								'div[data-widget-id="template-navbar1"] .navbar.fixed'
						  )
						: null;

					if (navbarHeightShrink !== null) {
						navbarHeightCalc =
							navbarHeight + navbarHeightShrink.offsetHeight;
					} else if (
						navbarHeightFixedMobile !== null &&
						navbarHeight === 0
					) {
						navbarHeightCalc = navbarHeightFixedMobile.offsetHeight;
					} else {
						navbarHeightCalc = navbarHeight;
					}

					const isScrolled = useScrollEffect(
						this.stickyFiltersRef,
						navbarHeightCalc
					);

					const stickyClasses = ['bg-contrast-med fixed-top p-4'];
					const filterClasses = [
						'facet-filters d-flex align-items-baseline'
					];

					return (
						<div
							className="facet-filters-ref"
							ref={this.stickyFiltersRef}
						>
							<div
								className={setClassNames([
									filterClasses,
									isScrolled && !isDesktop
										? stickyClasses
										: ''
								])}
								style={{
									top:
										isScrolled && !isDesktop
											? navbarHeightCalc
											: ''
								}}
							>
								<div className="d-lg-flex align-items-baseline">
									<VehicleCount
										count={invCount}
										hasFilters={!!appliedFilters.length}
									/>
									{!!appliedFilters.length && (
										<FilterItemList>
											{appliedFilters.map(filter =>
												filter.values.map(item => (
													<FilterItem
														{...item}
														key={[
															filter.id,
															item.value
														].join('-')}
														filterId={filter.id}
														filterLabel={
															filter.label
														}
														labels={labels}
														showRemoveButton={
															item.showRemoveButton
														}
													/>
												))
											)}
											<ClearFilters buttonClasses="d-none d-lg-inline-block" />
										</FilterItemList>
									)}
									{/* Display for no results when no facets are selected */}
									{!appliedFilters.length &&
										totalCount === 0 && (
											<FilterItemList>
												<ClearFilters
													label={labels.get(
														'CLEAR_FILTERS'
													)}
													buttonClasses="d-none d-md-inline-block"
												/>
											</FilterItemList>
										)}
									<AppliedFilters
										count={appliedFilters.length}
										labels={labels}
										isScrolled={isScrolled}
										{...{
											appliedFilters,
											labels
										}}
									/>
								</div>
								<div
									id="card-layout-toggle-portal"
									className="ml-auto flex-shrink-0"
								/>
								<FilterModalButton
									sortOptions={sortOptions}
									count={invCount}
									appliedFilters={appliedFilters}
								/>
								<div className="flex-shrink-0 d-none d-lg-block ml-4">
									<InventorySort
										{...{ sortOptions }}
										displayStyle="transparent"
									/>
								</div>
							</div>
						</div>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	locale: PropTypes.string.isRequired,
	deviceType: PropTypes.string.isRequired,
	labels: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => {
	const {
		requestData: { deviceType, locale },
		labels
	} = state;

	return {
		locale,
		deviceType,
		labels
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
